import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * Stockage des informations globales/communes pour l'application (paramètres/messages globaux,
 * données éphémères permettant de lier deux contextes, etc.).
 */
const appGlobalStore = defineStore('appGlobal', () => {

  /** paramètre retourné par le backend et définissant la possibilité d'effectuer ou non des réservation */
  const isBookingEnabled = ref<boolean>(true);

  const backendErrorThrown = ref<boolean>(false);

  /** État d'ouverture du menu mobile. */
  const mobileMenuOpen = ref<boolean>(false);

  function setBookingEnabled(isEnabled: boolean) {
    isBookingEnabled.value = isEnabled;
  }

  function setBackendErrorThrown(hasThrown: boolean) {
    backendErrorThrown.value = hasThrown;
  }

  /**
   * Ouvre ou ferme le menu mobile.
   */
  function setMobileMenuOpen(open: boolean) {
    mobileMenuOpen.value = open;
  }

  return {
    isBookingEnabled,
    backendErrorThrown,
    mobileMenuOpen,
    setBookingEnabled,
    setBackendErrorThrown,
    setMobileMenuOpen,
  };
});

export default appGlobalStore;

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(appGlobalStore, import.meta.hot));
}
